<template>
  <el-dialog v-model="visible" title="查看合同" width="800px" :before-close="handleClose">
    <div class="contract-box">
      <div v-html="content" class="contract-content"></div>
    </div>
    <template #footer>
          <span class="dialog-footer">
            <el-button @click="handleClose">关闭</el-button>
          </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "open-contract",
  data() {
    return {
      visible: false,
      content: ""
    }
  },
  mixins: [tableBase],
  methods: {
    handleClose() {
      this.visible = false;
    },
    open(row) {
      this.content = row.content;
      this.visible = true;
    },

  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>
.contract-box{
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 20px;
  height: 600px;
  overflow-y: auto;
}
</style>
